import React from "react"

import type { MetricRecord } from "@/metrics/runtime"

import type { RunsKeysetFilters } from "../hooks/useRunsInfiniteQuery"
import { useRunsSummaryPublisher } from "../hooks/useRunsSummaryPublisher"
import type { RunsPageSummaryRow } from "../utils/runsSummaryTypes"

interface RunsSummaryPublisherProps {
  filters: RunsKeysetFilters
  agentNames?: Record<string, string>
  enabled?: boolean
  metricDisplayNames?: Record<string, string>
  metricRecordsById?: Record<string, MetricRecord | undefined>
  personasById?: Record<string, { display_name?: string } | undefined>
  runs?: RunsPageSummaryRow[]
  simulations?: RunsPageSummaryRow[]
  testSetNames?: Record<string, string>
}

/**
 * Renders nothing: the simulations summary lives on the app-shell "Ask Sofia"
 * button, not in the page body. Kept as a memoized component rather than a hook
 * call inside `RunsTable` so that the insights queries settling re-render only
 * this leaf instead of the whole table.
 */
export const RunsSummaryPublisher = React.memo(
  ({
    agentNames,
    enabled = true,
    filters,
    metricDisplayNames,
    metricRecordsById,
    personasById,
    runs,
    simulations,
    testSetNames,
  }: RunsSummaryPublisherProps) => {
    useRunsSummaryPublisher({
      agentNames,
      enabled,
      filters,
      metricDisplayNames,
      metricRecordsById,
      personasById,
      runs,
      simulations,
      testSetNames,
    })

    return null
  },
)

RunsSummaryPublisher.displayName = "RunsSummaryPublisher"
